import React, { useMemo, useState } from 'react';
import UnifiedTable from '../../components/Indexes/UnifiedTable';
import useUserContext from '../../hooks/useUserContext';
import { isAdminRead } from '../../services/rolesSvc';

const PartUnifiedTable = () => {
  const userCtx = useUserContext();
  const [allRowsExpanded, setAllRowsExpanded] = useState(false);
  const [originalData, setOriginalData] = useState([]);

  const toggleExpand = () => {
    setOriginalData((prev) => prev.map((d) => ({ ...d, tableData: { isTreeExpanded: !allRowsExpanded } })));
    setAllRowsExpanded((prev) => !prev);
  };

  const canExport = useMemo(() => userCtx.perms.includes('kpiAdmin') || isAdminRead(userCtx), []);

  return (
    <UnifiedTable
      canExport={canExport}
      hasChildData={true}
      data={{ originalData, setOriginalData }}
      tableProps={{
        isExpandable: true,
        allRowsExpanded,
        toggleExpand,
      }}
    />
  );
}

export default PartUnifiedTable;
